export default "__VITE_ASSET__c9c40cd6__"